var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.106 11.938l4.608-4.607a1 1 0 011.414 0l.364.363a1 1 0 010 1.414l-5.657 5.657a1 1 0 01-1.414 0l-.079-.078a1.259 1.259 0 01-.155-.132L4.884 9.252a1.25 1.25 0 111.768-1.768l4.454 4.454z",
    id: "chevron_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron_svg__a",
    transform: "translate(-4 -7)",
    fillRule: "evenodd"
  })));
}
export default SvgChevron;